class exports.MultiDeleteDialog extends DialogHandler
    init: () ->
        @layoutSource = $('.multidelete-dialog')
        @layoutUrl = null
        @defaultSave = false
        @classes = 'small_dialog'
        #@refreshNavHandler = false
        @modalOptions = {
            backdrop: true
        }
        @createDialog()


    afterLoadLayout: () ->
        ths = this

        msgwriter = @dialog.find('.message_writer')
        msgwriter.message_writer
            autoHide: false


        if @saveData.objects?
            @dialog.find('.multidelete-num').text @saveData.objects.length
            for v in @saveData.objects
                @dialog.find('.multidelete-items').append "#{v.name}<br />"


        @saveAction = () =>
            if msgwriter.length isnt 0 and $.contains(document, msgwriter[0])
                msgwriter.message_writer 'info', 'Deleting...'
            total = @saveData.objects.length
            completed = 0
            successful = 0

            msgdata =
                status:
                    type: null
                    msg: null
                data:
                    messages: {}

            for v in @saveData.objects
                url = v.url ? @saveUrl
                $.ajax
                    type: 'post'
                    url: url
                    obj_data: v       # so we can reference this in the callback safely
                    data:
                        id: v.id
                        extra: v.element.data()
                    success: (data) ->
                        v = @obj_data
                        if data.status?
                            if data.status.type is 'success'
                                v.element.remove()
                                successful++
                                ths.multi_widget.element.trigger 'deleteOneSuccess', data
                            else
                                msgdata.data.messages["#{v.id}"] = "#{v.name} - #{data.status.msg}"
                                if data.data?.messages?
                                    msgdata.data.messages["#{v.id}"] = "#{v.name}<br />" +
                                        ths.listMessages data.data.messages
                                ths.multi_widget.element.trigger 'deleteOneFailure', data

                            completed++

                        else
                            completed++
                            errs = msgdata.data.messages["#{v.id}"] = "#{v.name} could not be deleted"
                            ths.multi_widget.element.trigger 'deleteOneFailure', data

                        if completed is total
                            if successful > 0
                                ths.triedSave = true
                            status = {}
                            status.count = {}
                            if successful is total
                                status.status = 'success'
                                status.count.success = total
                                status.count.failure = 0
                                ths.multi_widget.element.trigger 'deleteAllComplete', status
                                msgdata.status.type = 'success'
                                msgdata.status.msg = "#{total} items deleted successfully"


                                ths.multi_widget._cleanUp()
                            else
                                msgdata.status.type = 'error'
                                msgdata.status.msg = 'The following errors were encountered:'
                                status.status = 'failure'
                                status.count.success = successful
                                status.count.failure = completed - successful

                            ths.afterSave msgdata

        @afterHidden = () =>
            #if @triedSave? is true
            #    App.current_page.refreshSubHandlers()
            @multi_widget._cleanUp()

        @openDialog()



    #saveAction: () ->
    #    alert "HIE"

    submitAction: () ->
        @save('')
